<script>
import { defineComponent as _defineComponent } from "vue";
import { unref as _unref, renderSlot as _renderSlot, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, Transition as _Transition, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["data-active"];
import { inject, computed } from "vue";
import { defu } from "defu";
import { AutoSize } from "@maas/vue-autosize";
import { Primitive } from "@maas/vue-primitive";
import { useAccordionView } from "../composables/private/useAccordionView";
import { useAccordionState } from "../composables/private/useAccordionState";
import { useAccordionCallback } from "../composables/private/useAccordionCallback";
import { MagicAccordionInstanceId, MagicAccordionViewId } from "../symbols";
import "@maas/vue-equipment/utils/css/animations/fade-in.css";
import "@maas/vue-equipment/utils/css/animations/auto-size-out.css";
import "@maas/vue-equipment/utils/css/easings.css";
export default /* @__PURE__ */ _defineComponent({
  __name: "MagicAccordionContent",
  props: {
    asChild: { type: Boolean, required: false },
    transition: { type: String, required: false },
    animation: { type: Object, required: false }
  },
  setup(__props) {
    const instanceId = inject(MagicAccordionInstanceId, void 0);
    const viewId = inject(MagicAccordionViewId, void 0);
    if (!instanceId) {
      throw new Error("MagicMenuContent must be nested inside MagicMenuProvider");
    }
    if (!viewId) {
      throw new Error("MagicMenuContent must be nested inside MagicMenuView");
    }
    const { initializeState } = useAccordionState(instanceId);
    const state = initializeState();
    const { getView } = useAccordionView(instanceId);
    const view = getView(viewId);
    const mappedTransition = computed(() => __props.transition ?? state.options.transition);
    const mappedAnimation = computed(() => defu(__props.animation, state.options.animation));
    const {
      onBeforeEnter,
      onEnter,
      onAfterEnter,
      onBeforeLeave,
      onLeave,
      onAfterLeave
    } = useAccordionCallback({
      instanceId,
      viewId
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "magic-accordion-content",
        "data-active": _unref(view)?.active,
        style: _normalizeStyle({ "--ma-duration": `${_unref(state).options.animation?.duration}ms` })
      }, [
        _createVNode(_unref(AutoSize), {
          width: false,
          duration: mappedAnimation.value.duration,
          easing: mappedAnimation.value.easing
        }, {
          default: _withCtx(() => [
            _createVNode(_Transition, {
              name: mappedTransition.value,
              "on-before-enter": _unref(onBeforeEnter),
              "on-enter": _unref(onEnter),
              "on-after-enter": _unref(onAfterEnter),
              "on-before-leave": _unref(onBeforeLeave),
              "on-leave": _unref(onLeave),
              "on-after-leave": _unref(onAfterLeave),
              persisted: ""
            }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_unref(Primitive), { "as-child": _ctx.asChild }, {
                  default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "default", {
                      viewActive: _unref(view)?.active
                    })
                  ]),
                  _: 3
                  /* FORWARDED */
                }, 8, ["as-child"]), [
                  [_vShow, _unref(view)?.active]
                ])
              ]),
              _: 3
              /* FORWARDED */
            }, 8, ["name", "on-before-enter", "on-enter", "on-after-enter", "on-before-leave", "on-leave", "on-after-leave"])
          ]),
          _: 3
          /* FORWARDED */
        }, 8, ["duration", "easing"])
      ], 12, _hoisted_1);
    };
  }
});
</script>

<style>
.magic-accordion-content {
  clip-path: var(--magic-accordion-content-clip-path, inset(0));
}

.magic-accordion-enter-active {
  position: relative;
  animation: fade-in var(--ma-duration) var(--ease-in-out);
}

.magic-accordion-leave-active {
  animation: auto-size-out var(--ma-duration) var(--ease-in-out-sharp);
}
</style>
